/*
 * Must be imported before prismjs: tells Prism not to highlight the page by
 * itself as soon as it loads. The runtime highlights once the languages the
 * page needs are there.
 */
window.Prism = window.Prism || {};
window.Prism.manual = true;
